module.exports = __webpack_public_path__ + "img/ad.6a5401a9.svg";